import styled from 'styled-components';

export const Wrapper = styled.span<{
  status: string;
}>`
  background: ${({ status }) =>
    function getBackground() {
      switch (status) {
        case 'Agendada':
          return '#FDB81E';
        case 'Realizada':
          return '#38B449';
        case 'Cancelada':
          return '#F44336';
        default:
          return '#FDB81E';
      }
    }};
  width: fit-content;
  border-radius: 4px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${({ status }) => (status === 'Agendada' ? '#000000E0' : '#FFF')};
`;
